import React from 'react';
import './MeetingTableSkeleton.css';

/**
 * Skeleton loader component for the meetings table
 * Provides visual feedback while meetings are loading
 */
const MeetingTableSkeleton = ({ rowCount = 10 }) => {
  return (
    <div className="meeting-skeleton-table-wrapper">
      <table className="meeting-skeleton-table">
        {/* Table Header */}
        <thead>
          <tr className="meeting-skeleton-header-row">
            <th className="meeting-skeleton-th meeting-skeleton-th-title" />
            <th className="meeting-skeleton-th meeting-skeleton-th-host" />
            <th className="meeting-skeleton-th meeting-skeleton-th-date" />
            <th className="meeting-skeleton-th meeting-skeleton-th-status" />
            <th className="meeting-skeleton-th meeting-skeleton-th-action" />
          </tr>
        </thead>

        {/* Table Body with Skeleton Rows */}
        <tbody>
          {Array.from({ length: rowCount }).map((_, index) => (
            <tr
              key={index}
              className={`meeting-skeleton-row ${index % 2 === 1 ? 'odd' : ''}`}
            >
              <td className="meeting-skeleton-td meeting-skeleton-td-title">
                <div className="skeleton-shimmer skeleton-text-long" />
              </td>
              <td className="meeting-skeleton-td meeting-skeleton-td-host">
                <div className="skeleton-shimmer skeleton-text-short" />
              </td>
              <td className="meeting-skeleton-td meeting-skeleton-td-date">
                <div className="skeleton-shimmer skeleton-text-short" />
              </td>
              <td className="meeting-skeleton-td meeting-skeleton-td-status">
                <div className="skeleton-shimmer skeleton-badge" />
              </td>
              <td className="meeting-skeleton-td meeting-skeleton-td-action">
                <div className="skeleton-shimmer skeleton-button-small" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MeetingTableSkeleton;
